<template>
  <div class="about-wrapper">

    <!-- Reuse same background orbs for consistency -->
    <div class="bg-canvas">
      <div class="orb orb-1"></div>
      <div class="orb orb-2"></div>
      <div class="grid-lines"></div>
    </div>

    <div class="container about-page">

      <!-- ── Education ── -->
      <section class="timeline-section reveal">
        <div class="section-heading">
          <span class="section-tag">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3zM5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82z"/></svg>
            Education
          </span>
          <h2 class="section-title">Academic Background</h2>
        </div>

        <div class="timeline">

          <div class="timeline-item reveal delay-1">
            <div class="timeline-left">
              <span class="timeline-date">2023 – Present</span>
              <div class="timeline-line"></div>
              <div class="timeline-dot"></div>
            </div>
            <div class="timeline-card">
              <div class="card-icon card-icon--edu">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3zM5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82z"/></svg>
              </div>
              <div class="card-body">
                <h4 class="card-title">Bachelor of Computer Science</h4>
                <p class="card-sub">Software Development</p>
                <p class="card-location">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
                  Swinburne University of Technology
                </p>
              </div>
            </div>
          </div>

          <div class="timeline-item reveal delay-2">
            <div class="timeline-left">
              <span class="timeline-date">2022 – 2023</span>
              <div class="timeline-line"></div>
              <div class="timeline-dot"></div>
            </div>
            <div class="timeline-card">
              <div class="card-icon card-icon--edu">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3zM5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82z"/></svg>
              </div>
              <div class="card-body">
                <h4 class="card-title">Diploma of Information & Communication Technology</h4>
                <p class="card-location">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
                  Swinburne University of Technology
                </p>
              </div>
            </div>
          </div>

        </div>
      </section>

      <!-- ── Work Experience ── -->
      <section class="timeline-section reveal">
        <div class="section-heading">
          <span class="section-tag">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><path d="M20 7h-4V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2H4a2 2 0 00-2 2v11a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2zm-10-2h4v2h-4V5z"/></svg>
            Work Experience
          </span>
          <h2 class="section-title">Where I've Worked</h2>
        </div>

        <div class="timeline">

          <div class="timeline-item reveal delay-1">
            <div class="timeline-left">
              <span class="timeline-date">May 2022 – Jan 2024</span>
              <div class="timeline-line"></div>
              <div class="timeline-dot timeline-dot--work"></div>
            </div>
            <div class="timeline-card">
              <div class="card-icon card-icon--work">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M20 7h-4V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2H4a2 2 0 00-2 2v11a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2zm-10-2h4v2h-4V5z"/></svg>
              </div>
              <div class="card-body">
                <div class="card-header-row">
                  <h4 class="card-title">Trianon Bakery and Cake Works</h4>
                  <span class="card-badge">Baker's Assistant</span>
                </div>
                <p class="card-location">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
                  Hawthorn, VIC 3122
                </p>
                <ul class="card-list">
                  <li>Provided excellent customer service by assisting customers with orders and inquiries.</li>
                  <li>Managed cash register operations and processed transactions accurately.</li>
                  <li>Ensured baked goods display was attractive and well-stocked.</li>
                  <li>Maintained cleanliness and organisation of the front-of-house area.</li>
                </ul>
              </div>
            </div>
          </div>

          <div class="timeline-item reveal delay-2">
            <div class="timeline-left">
              <span class="timeline-date">May 2022 – Dec 2023</span>
              <div class="timeline-line"></div>
              <div class="timeline-dot timeline-dot--work"></div>
            </div>
            <div class="timeline-card">
              <div class="card-icon card-icon--work">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M20 7h-4V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2H4a2 2 0 00-2 2v11a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2zm-10-2h4v2h-4V5z"/></svg>
              </div>
              <div class="card-body">
                <div class="card-header-row">
                  <h4 class="card-title">Piquancy Restaurant</h4>
                  <span class="card-badge">Waiter</span>
                </div>
                <p class="card-location">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
                  Hawthorn, VIC 3122
                </p>
                <ul class="card-list">
                  <li>Greeted and seated customers, presented menus and provided detailed information on dishes.</li>
                  <li>Collaborated with kitchen staff for timely and accurate order fulfilment.</li>
                  <li>Took accurate orders, delivered food and drinks, and ensured customer satisfaction.</li>
                </ul>
              </div>
            </div>
          </div>

        </div>
      </section>

    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutView',
  mounted() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.animationPlayState = 'running'
          observer.unobserve(entry.target)
        }
      })
    }, { threshold: 0.15 })

    document.querySelectorAll('.reveal').forEach(el => {
      el.style.animationPlayState = 'paused'
      observer.observe(el)
    })
  }
}
</script>

<style scoped>
/* ── Wrapper ── */
.about-wrapper {
  min-height: 100vh;
  background: #080810;
  position: relative;
  overflow: hidden;
}

/* ── Background (same as home) ── */
.bg-canvas {
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
}

.orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(90px);
}

.orb-1 {
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(124,111,234,0.15) 0%, transparent 70%);
  top: -100px;
  right: -100px;
  animation: floatOrb 16s ease-in-out infinite alternate;
}

.orb-2 {
  width: 420px;
  height: 420px;
  background: radial-gradient(circle, rgba(20,184,166,0.12) 0%, transparent 70%);
  bottom: 0;
  left: -80px;
  animation: floatOrb 20s ease-in-out infinite alternate-reverse;
}

.grid-lines {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(255,255,255,0.022) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255,255,255,0.022) 1px, transparent 1px);
  background-size: 64px 64px;
}

@keyframes floatOrb {
  from { transform: translate(0, 0); }
  to   { transform: translate(50px, 40px); }
}

/* ── Page ── */
.about-page {
  position: relative;
  z-index: 1;
  padding-top: 120px;
  padding-bottom: 100px;
  max-width: 860px;
}

/* ── Sections ── */
.timeline-section {
  margin-bottom: 72px;
}

/* ── Section heading ── */
.section-heading {
  margin-bottom: 36px;
}

.section-tag {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: rgba(124,111,234,0.1);
  border: 1px solid rgba(124,111,234,0.25);
  border-radius: 100px;
  padding: 5px 14px;
  font-size: 12px;
  color: #a89ff5;
  letter-spacing: 0.07em;
  font-family: 'DM Mono', monospace;
  margin-bottom: 14px;
}

.section-title {
  font-family: 'Sora', sans-serif;
  font-size: clamp(1.6rem, 3vw, 2.2rem);
  font-weight: 700;
  color: #f0eeff;
  letter-spacing: -0.02em;
  margin: 0;
}

/* ── Timeline ── */
.timeline {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.timeline-item {
  display: flex;
  gap: 0;
  align-items: stretch;
}

/* Left: date + line + dot */
.timeline-left {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 180px;
  min-width: 180px;
  padding-right: 28px;
  position: relative;
  padding-top: 28px;
}

.timeline-date {
  font-family: 'DM Mono', monospace;
  font-size: 11.5px;
  color: rgba(232,230,240,0.4);
  letter-spacing: 0.06em;
  white-space: nowrap;
  text-align: right;
  line-height: 1;
  margin-bottom: 10px;
}

.timeline-line {
  position: absolute;
  right: 7px;
  top: 0;
  bottom: 0;
  width: 1px;
  background: rgba(255,255,255,0.08);
}

.timeline-dot {
  position: absolute;
  right: 2px;
  top: 30px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: #7c6fea;
  box-shadow: 0 0 10px rgba(124,111,234,0.5);
  border: 2px solid #080810;
}

.timeline-dot--work {
  background: #14b8a6;
  box-shadow: 0 0 10px rgba(20,184,166,0.5);
}

/* Right: card */
.timeline-card {
  flex: 1;
  display: flex;
  gap: 16px;
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(255,255,255,0.07);
  border-radius: 14px;
  padding: 24px;
  transition: border-color 0.25s ease, background 0.25s ease;
  margin-bottom: 4px;
}

.timeline-card:hover {
  background: rgba(124,111,234,0.06);
  border-color: rgba(124,111,234,0.2);
}

/* Icon */
.card-icon {
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
}

.card-icon--edu {
  background: rgba(124,111,234,0.15);
  color: #a89ff5;
  border: 1px solid rgba(124,111,234,0.2);
}

.card-icon--work {
  background: rgba(20,184,166,0.12);
  color: #5eead4;
  border: 1px solid rgba(20,184,166,0.2);
}

/* Card content */
.card-body {
  flex: 1;
  min-width: 0;
}

.card-header-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 6px;
}

.card-title {
  font-family: 'Sora', sans-serif;
  font-size: 0.97rem;
  font-weight: 600;
  color: #e8e6f0;
  margin: 0;
  letter-spacing: -0.01em;
}

.card-sub {
  font-family: 'Sora', sans-serif;
  font-size: 0.85rem;
  color: rgba(232,230,240,0.45);
  margin: 0 0 6px;
}

.card-badge {
  font-family: 'DM Mono', monospace;
  font-size: 11px;
  padding: 3px 10px;
  border-radius: 100px;
  background: rgba(20,184,166,0.1);
  border: 1px solid rgba(20,184,166,0.22);
  color: #5eead4;
  letter-spacing: 0.05em;
  white-space: nowrap;
}

.card-location {
  display: flex;
  align-items: center;
  gap: 5px;
  font-family: 'DM Mono', monospace;
  font-size: 11.5px;
  color: rgba(232,230,240,0.35);
  margin: 0 0 14px;
}

.card-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.card-list li {
  font-family: 'Sora', sans-serif;
  font-size: 0.855rem;
  color: rgba(232,230,240,0.5);
  line-height: 1.6;
  padding-left: 16px;
  position: relative;
}

.card-list li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 9px;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: rgba(124,111,234,0.6);
}

/* ── Reveal animation ── */
.reveal {
  opacity: 0;
  transform: translateY(20px);
  animation: fadeUp 0.6s ease forwards;
  animation-play-state: paused;
}

.delay-1 { animation-delay: 0.1s; }
.delay-2 { animation-delay: 0.22s; }

@keyframes fadeUp {
  to { opacity: 1; transform: translateY(0); }
}

/* ── Responsive ── */
@media (max-width: 640px) {
  .timeline-left {
    width: 110px;
    min-width: 110px;
    padding-right: 20px;
  }

  .timeline-date {
    font-size: 10px;
  }

  .timeline-card {
    padding: 18px 16px;
    gap: 12px;
  }

  .card-icon {
    width: 28px;
    height: 28px;
  }

  .section-title {
    font-size: 1.4rem;
  }

  .about-page {
    padding-top: 100px;
  }
}

@media (max-width: 420px) {
  .timeline-left {
    width: 90px;
    min-width: 90px;
  }

  .timeline-date {
    font-size: 9.5px;
    white-space: normal;
    text-align: right;
  }
}
</style>